import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'projects/shared/src/lib/shared';

import { NavigationLinkModule } from '../../navigation/link/navigation-link.module';
import { SideBarNavigationComponent } from './side-bar-navigation.component';
import { AuthenticationService } from '../../../../authentication/authentication.service';

@NgModule({
  imports: [
    SharedModule,
    NavigationLinkModule,
    RouterModule
  ],
  declarations: [SideBarNavigationComponent],
  exports: [SideBarNavigationComponent],
  providers: [
    AuthenticationService
  ]
})
export class SideBarNavigationModule { }
